<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { BrandsSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: BrandsSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex flex-col items-center">
    <h2 class="mb-lg">
      {{ data.title }}
    </h2>

    <div v-if="data.optIntro" class="mb-3xl w-full text-center lg:w-2/5" v-html="data.optIntro" />

    <div class="p-lg rounded-lg bg-white">
      <div class="gap-md flex flex-wrap justify-center">
        <div v-for="item in data.items" :key="item.id">
          <NuxtLink v-if="item.optLinkUrl" :to="item.optLinkUrl" :target="getTarget(item.optLinkUrl)">
            <div class="group overflow-hidden">
              <DatocmsImage
                :data="item.logo.responsiveImage as ResponsiveImageType" object-fit="cover"
                class="max-w-[50px] transition-transform duration-300 ease-in-out group-hover:scale-105 lg:max-w-[100px]"
              />
            </div>
          </NuxtLink>

          <div v-else class="group overflow-hidden">
            <DatocmsImage
              :data="item.logo.responsiveImage as ResponsiveImageType" object-fit="cover"
              class="max-w-[50px] transition-transform duration-300 ease-in-out group-hover:scale-105 lg:max-w-[100px]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
